import { useState, useEffect, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import StorageLogoSrc from "../../assets/images/logo.svg";
import { Dropdown } from "../dropdown/Dropdown";
import { MainTabType, MainTab } from "../mainTabs/TabData";
import {
  NavBarContainer,
  StorageLogo,
  StorageLogoContainer,
  ButtonGroup,
  ProfileImage,
  ProfileLabel,
  IconWrapper,
  HiddenSideBar,
  SidebarHeader,
  ProfileDropdownWrapper,
  SidebarServiceLabel,
  SidebarServiceUrl,
  SidebarTabContainer,
  HiddenContainer,
  TabContainer,
  SidebarOverLay,
  SidebarServiceContainer,
  SideTabProfileContainer,
  SideTabProfileWWrapper,
  SidebarProfileTab,
} from "./NavBar.style";
import { useAppDispatch } from "../../store/hooks";
import { logout } from "../../store/modules/user";

interface NavBarProps {
  /**
   * Array of tab
   */
  tabs?: MainTab[];
  /**
   * User's label
   */
  user: string;
  /**
   * User's profile
   */
  userProfile?: string;
  /**
   * Service label
   */
  serviceLabel?: string;
  /**
   * Service url
   */
  serviceUrl?: string;
  /**
   * Set active tab
   */
  activeTab?: MainTabType;
}

export const NavBar = (props: NavBarProps) => {
  const {
    activeTab,
    user,
    userProfile,
    tabs,
    serviceLabel,
    serviceUrl,
  } = props;

  const [visible, setVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const dispatch = useAppDispatch();

  const PROFILE_OPTIONS = [
    {
      label: "My Buckets",
      icon: <FontAwesomeIcon size={"sm"} icon={["fas", "cloud"]} />,
      onClick: () => {
        window.location.href = `/?tab=mine`;
      },
    },
    {
      label: "Everyone’s Buckets",
      icon: <FontAwesomeIcon size={"sm"} icon={["fas", "clouds"]} />,
      onClick: () => {
        window.location.href = `/?tab=everyone`;
      },
    },
    {
      label: "Logout",
      icon: <FontAwesomeIcon icon={["fas", "sign-out-alt"]} />,
      onClick: () => {
        window.location.href = `/logout`;
        dispatch(logout());
        // localStorage.setItem("byteark-user", JSON.stringify({}));
      },
    },
  ];

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [visible]);

  return (
    <NavBarContainer>
      <SidebarOverLay isActive={visible} onClick={() => setVisible(false)} />
      <HiddenSideBar isActive={visible}>
        <SidebarHeader>
          <StorageLogoContainer to={"/"}>
            <StorageLogo src={StorageLogoSrc} />
            Storage
          </StorageLogoContainer>
          <FontAwesomeIcon
            icon={["fas", "times"]}
            onClick={() => setVisible(false)}
            size="lg"
          />
        </SidebarHeader>
        <SidebarServiceContainer>
          <SidebarServiceLabel>{serviceLabel}</SidebarServiceLabel>
          {serviceUrl && <SidebarServiceUrl>{serviceUrl}</SidebarServiceUrl>}
        </SidebarServiceContainer>
        <SidebarTabContainer>
          {tabs &&
            tabs.map((mainTab) => (
              <Fragment key={`main-${mainTab.label}`}>
                <TabContainer
                  to={mainTab.redirectUrl}
                  type={"main" as any}
                  onClick={() => {}}
                  isActive={activeTab === mainTab.label}
                >
                  {mainTab.label}
                </TabContainer>
              </Fragment>
            ))}
        </SidebarTabContainer>
        <SideTabProfileContainer
          onClick={() => setProfileVisible(!profileVisible)}
        >
          <SideTabProfileWWrapper>
            <ProfileImage>
              {userProfile ? (
                <FontAwesomeIcon icon={["fas", "user"]} />
              ) : (
                <img src={userProfile} alt={user} />
              )}
            </ProfileImage>
            <ProfileLabel>{user}</ProfileLabel>
          </SideTabProfileWWrapper>
          <FontAwesomeIcon
            icon={profileVisible ? ["far", "angle-down"] : ["far", "angle-up"]}
          />
        </SideTabProfileContainer>
        <HiddenContainer isActive={profileVisible}>
          {PROFILE_OPTIONS.map((option) => (
            <SidebarProfileTab
              onClick={() => option.onClick()}
              key={`profile-${option.label}`}
            >
              {option.icon} {option.label}
            </SidebarProfileTab>
          ))}
        </HiddenContainer>
      </HiddenSideBar>
      <IconWrapper>
        <FontAwesomeIcon
          icon={["fas", "bars"]}
          size="lg"
          onClick={() => setVisible(true)}
        />
      </IconWrapper>
      <StorageLogoContainer to={"/"}>
        <StorageLogo src={StorageLogoSrc} />
        Storage
      </StorageLogoContainer>
      <ButtonGroup>
        <ProfileDropdownWrapper>
          <Dropdown options={PROFILE_OPTIONS}>
            <ProfileImage>
              <FontAwesomeIcon icon={["fas", "user"]} />
            </ProfileImage>
            <ProfileLabel>{user}</ProfileLabel>
            <FontAwesomeIcon icon={["fas", "caret-down"]} />
          </Dropdown>
        </ProfileDropdownWrapper>
      </ButtonGroup>
      <IconWrapper>
        <FontAwesomeIcon icon={["fas", "cog"]} size="lg" />
      </IconWrapper>
    </NavBarContainer>
  );
};
